import { render } from "./HealthPermit.vue?vue&type=template&id=59457181&scoped=true"
import script from "./HealthPermit.vue?vue&type=script&lang=js"
export * from "./HealthPermit.vue?vue&type=script&lang=js"

import "./HealthPermit.vue?vue&type=style&index=0&id=59457181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59457181"]])

export default __exports__